import {
  CORE_LOAD_USER_INFO_REQUEST,
  CORE_LOAD_USER_INFO_SUCCESS,

  O365_LOAD_USER_INFO_REQUEST,
  O365_LOAD_USER_INFO_SUCCESS,

  CORE_LOAD_INTEGRATION_REQUEST,
  CORE_LOAD_INTEGRATION_SUCCESS,

  CORE_LOAD_O365URL_REQUEST,
  CORE_LOAD_O365URL_SUCCESS,

  CORE_REMOVE_INTEGRATION_SUCCESS,

  O365_USER_LIST_REQUEST,
  O365_USER_LIST_SUCCESS,

  SERVICE_SEARCH_USERS_REQUEST,
  SERVICE_SEARCH_USERS_SUCCESS,

  CORE_GETURL_GOOGLE_REQUEST,
  CORE_GETURL_GOOGLE_SUCCESS,

} from '../../types'

const initialState = []

export default {
  users: (state = initialState, action) => {
    switch (action.type) {
      case O365_USER_LIST_REQUEST:
      case SERVICE_SEARCH_USERS_REQUEST:
        return initialState
      case O365_USER_LIST_SUCCESS:
      case SERVICE_SEARCH_USERS_SUCCESS:
        if (action.payload)
          return action.payload
        else return []
      default:
        return state
    }
  },
  user: (state = {}, action) => {
    switch (action.type) {
      case CORE_LOAD_USER_INFO_REQUEST:
      case O365_LOAD_USER_INFO_REQUEST:
        return {}
      case CORE_LOAD_USER_INFO_SUCCESS:
      case O365_LOAD_USER_INFO_SUCCESS:
        return action.payload
      default:
        return state
    }
  },
  integration: (state = {}, action) => {
    switch (action.type) {
      case CORE_LOAD_INTEGRATION_REQUEST:
      case CORE_REMOVE_INTEGRATION_SUCCESS:
        return {}
      case CORE_LOAD_INTEGRATION_SUCCESS:
        return action.payload

      default:
        return state
    }
  },
  o365Url: (state = {}, action) => {
    switch (action.type) {
      case CORE_LOAD_O365URL_REQUEST:
        return {}
      case CORE_LOAD_O365URL_SUCCESS:
        return action.payload

      default:
        return state
    }
  },
  urlGoogle: (state = {}, action) => {
    switch (action.type) {
      case CORE_GETURL_GOOGLE_REQUEST:
        return null
      case CORE_GETURL_GOOGLE_SUCCESS:
        return action.payload

      default:
        return state
    }
  }
}


// WEBPACK FOOTER //
// ./src/features/user/reducer.js